module.exports = __webpack_public_path__ + "img/model.379147a6.gif";